// @react
import React from 'react'
// @graphQL
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
// @types
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
// @components
import QueryError from 'modules/common/components/Errors/QueryError'
import ContactForm from 'modules/profile/components/ContactInformation/Form'
/**
 * 5.0.1.5 MyATD - Profile - Contact Info
 * UX: https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3123%3A16072
 *
 * fields:
 * User/contactInfo	primaryPhoneNumber
 * User/contactInfo	secondaryPhoneNumber
 * User/contactInfo	primaryEmailAddress
 * User/contactInfo	address
 *
 */

type PropsType = Record<string, unknown>

const ContactInformation = ({}: PropsType, ref: React.Ref<HTMLDivElement>) => {
  /****************************************
   *  GQL HOOKS
   ****************************************/

  const { loading: isLoading, error: isError, data, refetch } = useQuery<
    GetUserQuery,
    GetUserQueryVariables
  >(GET_USER, { fetchPolicy: 'cache-first', notifyOnNetworkStatusChange: true })

  /****************************************
   *  RENDER
   ****************************************/

  if (isError || (!data && !isLoading)) {
    return <QueryError />
  }

  return (
    <div ref={ref}>
      <ContactForm data={data} isLoading={isLoading} refetch={refetch} />
    </div>
  )
}

export default React.forwardRef<HTMLDivElement>(ContactInformation)
